import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Drawer from "react-drag-drawer";
import { FiX } from 'react-icons/fi';
import { playSong } from '../../utils/song'
import songsName from '../../enums/songsName'
import api from '../../services/api';
import Loading from '../loading';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { BsArrowLeftCircle, BsX} from 'react-icons/bs';
import { useFormik } from 'formik';
import Button from '../button'
import { getFields } from '../../utils/form'
import * as yup from 'yup'
import RecoveryPassword from './components/reset-password';
import toast from 'react-hot-toast';
import clsx from 'clsx';
import Loader from 'react-loader-spinner'
import { AnimatePresence, motion } from 'framer-motion'
import { PRODUCT } from '../../consts/product';
import { sleep } from '../../utils/helper';
import LogoPng from '../../assets/images/new/dum-dum-logo.png'
import { GUEST_PROVIDER_NAME, SUBSCRIBER_PROVIDER_NAME } from '../../consts/common';
import GhostButton from '../ghost-button';

const slideVariants = {
  hidden: { opacity: 0, x: "100vw", transition: { duration: 0.2, delay: 0 } },
  visible: { opacity: 1, x: "0vw", transition: { duration: 0.2, delay: 0.5 } },
  exit: { opacity: 0, x: "-100vw", transition: { duration: 0.2, delay: 0 } },
};

const regexTel =
    /^\(\d{2}\) \d{5}-\d{4}|\((?:1[2-9]|[2-9]\d)\) [5-9]\d{3}-\d{4}$/;
  const regexCnpjCpf =
    /^([0-9]{2}[.]?[0-9]{3}[.]?[0-9]{3}[/]?[0-9]{4}[-]?[0-9]{2})|([0-9]{3}[.]?[0-9]{3}[.]?[0-9]{3}[-]?[0-9]{2})$/;

const LoginModal = (props) => {
  const [isLoading, setIsLoading] = useState(true)

  const [access, setAccess] = useState([])
  const [method, setMethod] = useState(null)

  const [showFirstAccessConfirmationModal, setShowFirstAccessConfirmationModal] = useState(false)

  const {
    values,
    errors,
    touched,
    resetForm,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
  } = useFormik({
    initialValues: { email: "", msisdn: "", password: "", cpfcnpj: "", username: "" },
    validate: (values) => {
      const errors = {};

      method.formfieldslogin.forEach((field) => {
        if (field.name === "username") {
          if (!new RegExp(field.validation).test(values.username)) {
            errors.username = field.validation_message;
          }

          if (values.username === "") {
            errors.username = "Campo obrigatório";
          }
        }

        if (field.name === 'email') {
          if (field.validation === "email") {
            const schema = yup.string().email()
            const result = schema.isValidSync(values.email)

            if (!result) {
              errors.email = field.validation_message;
            }

            if (!values.email) {
              errors.email = "Campo obrigatório";
            }
          }
        }

        if (field.name === "cpfcnpj") {
          if (field.validation === "cpf_cnpj") {
            if (values.cpfcnpj.match(regexCnpjCpf) === null) {
              errors.cpfcnpj = field.validation_message;
            }
          } else {
            if (!new RegExp(field.validation).test(values.cpfcnpj)) {
              errors.cpfcnpj = field.validation_message;
            }

            if (values.cpfcnpj === "") {
              errors.cpfcnpj = "Campo obrigatório";
            }
          }
        }

        if (field.name === "password") {
          if (!new RegExp(field.validation).test(values.password)) {
            errors.password = field.validation_message;
          }

          if (values.password === "") {
            errors.password = "Campo obrigatório";
          }
        }

        if (field.name === "msisdn") {
          if (values.msisdn.match(regexTel) === null) {
            errors.msisdn = field.validation_message;
          }

          if (values.msisdn === "") {
            errors.msisdn = "Campo obrigatório";
          }
        }
      });

      return errors;
    },
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      const { idp, auth } = method;
      const data = {
        idp,
        auth,
        produto: PRODUCT,
      };

      Object.entries(values).forEach((item) => {
        let key = item[0]
        let value = item[1]

        if (!!value) {
          if (key === 'msisdn') {
            value = `+55${value.replace(/\D/g, "")}`
          }

          if (value === 'cpfcnpj') {
            value = value.replace(/\D/g, "")
          }

          data[key] = value
        }
      })

      try {
        const response = await api.post('/covportfolio', data)
        if (response.data.email) {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'PURCHASE_LOGIN',
            payload: {
              identifier: response.data.email
            }
          }))
  
          await sleep(500)
        }

        props.onLoginSuccess(response.data)
        
        await sleep(500)
        const hash = window.localStorage.getItem('@cov/hash')
        const portfolioResponse = await api.get(`/covportfolio/${hash ?? ''}`)
        props.onPortfolioLoaded(portfolioResponse.data)
        props.updateSubscriberData(response.data)
        props.updateLoginProvider(method?.operadora)
  
        props.close()
        setMethod(undefined)
  
        resetForm({
          email: "",
          msisdn: "",
          password: "",
          cpfcnpj: "",
          username: ""
        })
      } catch {
        setTimeout(() => {
          playSong(songsName.SEAGULLS)
        
          toast.error("Credenciais inválidas. Por favor, verifique e tente novamente.")
        }, 1000);
      } finally {
        setSubmitting(false);
      }
    }
  })

  const isPatternSelectedForLogin = useMemo(() => {
    const patternsAccess = access?.find(item => !!item.patterns)
    return !!patternsAccess?.patterns?.find(pattern => pattern?.operadora === method?.operadora)
  }, [access, method])

  const [showRecoveryPasswordForm, setShowRecoveryPasswordForm] = useState(false)

  const loadAccess = useCallback(async () => {
    const { data: payload } = await api.get('/operadora', {
      params: {
        appaccess: 1
      }
    })

    const data = payload.categoria.map((item) => {
      if (item.convidados?.length) {
        return item.convidados[0]
      }

      if (item.assinantes?.length) {
        return item.assinantes[0]
      }

      return item
    })

    setAccess(data)
  }, [])

  useEffect(() => {
    setIsLoading(true)

    loadAccess().finally(() => {
      setIsLoading(false)
    })

    }, [loadAccess])

  const closeHandler = () => {
    playSong(songsName.TAP)
    props.close()

    setShowRecoveryPasswordForm(false)

    setMethod(null)
    resetForm({ email: "", msisdn: "", password: "", cpfcnpj: "", username: "" })
  }

  const forgotPasswordHandler = useCallback(async () => {
    if (!values.email.length) {
      toast('Preencha o email para solicitar a recuperação da senha')
      return
    }

    try {
      await api.post("/vamole/app/password", {
        "email": values.email,
        "produto": PRODUCT
      })
      toast.success('Você receberá um código por e-mail se seu e-mail for encontrado em nossa base de dados')
      setShowRecoveryPasswordForm(true)
    } catch {
      toast.error('Não foi possível solicitar a troca da senha, por favor contate a equipe de suporte')
    }
  }, [values.email])

  const renderContent = useCallback(() => {
    if (isLoading) {
      return (
        <div className='flex flex-1 w-full flex-col justify-center items-center'>
          <Loading />
        </div>
      )
    }

    if (showRecoveryPasswordForm) {
      return <RecoveryPassword email={values.email} close={() => setShowRecoveryPasswordForm(false)} />
    }

    if (!method) {
      return (
        <div className='w-full flex flex-col gap-x-4'>
          {access.map((item, index) => {
            return (
              <div
                key={index}
                className='w-full flex flex-col cursor-pointer border-b border-b-black'
                onMouseEnter={() => {
                  playSong(songsName.TAP)
                }}
                onClick={() => {
                  playSong(songsName.TAP)

                  setMethod(item)
                }}
              >
                <div className="w-full flex flex-1 flex-row justify-start items-center py-4">
                  <div className="w-full flex flex-1 flex-row justify-start items-center mr-4">
                    <div className="w-9 h-10 rounded-lg overflow-hidden mr-2">
                      <img className='w-full h-full blend-mode-multiply object-contain' src={item.icon} alt={`item${index}`} />
                    </div>
                    <span>{item.operadora ?? item.item}</span>
                  </div>

                  <MdKeyboardArrowRight size={40} color="#000000AA" />
                </div>
              </div>
            );
          })}

          <div className='w-full flex flex-col justify-center items-center text-lg mt-6'>
            <p>Ainda não possui uma assinatura?</p>
            <p
              className='underline cursor-pointer text-blue-primary font-bold'
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={() => {
                playSong(songsName.TAP)

                // if (window.in_native_app && window.platform === 'android') {
                //   window.ReactNativeWebView.postMessage(JSON.stringify({
                //     type: 'OPEN_REGISTRATION',
                //   }))
            
                //   return
                // }
                
                props.openRegistration()
              }}
            >
              Assinar agora
            </p>
          </div>
        </div>
      )
    }

    if (method && method?.patterns?.length) {
      return (
        <div className='w-full h-full flex flex-col'>
          <div className='w-full h-full flex flex-col gap-x-4 overflow-auto'>
            {method?.patterns?.map((item, index) => {
              return (
                <div
                  key={index}
                  className='w-full flex flex-col cursor-pointer border-b border-b-black'
                  onMouseEnter={() => {
                    playSong(songsName.TAP)
                  }}
                  onClick={() => {
                    playSong(songsName.TAP)
                    setMethod(item)
                  }}
                >
                  <div className="w-full flex flex-1 flex-row justify-start items-center py-4">
                    <div className="w-full flex flex-1 flex-row justify-start items-center mr-4">
                    <div className="w-9 h-10 rounded-lg overflow-hidden mr-2">
                      <img className='w-full h-full blend-mode-multiply object-contain' src={item.icon} alt={`item${index}`} />
                    </div>
                      <span>{item.operadora ?? item.item}</span>
                    </div>

                    <MdKeyboardArrowRight size={40} color="#000000AA" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )
    }

    return (
      <form className='w-full flex flex-col gap-y-2' onSubmit={handleSubmit}>
        {method?.operadora === SUBSCRIBER_PROVIDER_NAME ? <p className='text-sm mb-2 font-medium'>Se você tem uma assinatura, digite o e-mail e sua senha para entrar</p> : null}
        {method.dicalogin && method?.operadora !== SUBSCRIBER_PROVIDER_NAME ? <p className='text-sm mb-2 font-medium'>{method.dicalogin}</p> : null}
        
        {method.formfieldslogin.map((field) =>
          getFields(
            field,
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            false,
            method?.operadora === GUEST_PROVIDER_NAME
          )
        )}
        {method?.operadora === SUBSCRIBER_PROVIDER_NAME ? (
          <p
            onClick={forgotPasswordHandler}
            className='cursor-pointer underline text-sm text-right mb-4'
          >
              Esqueci minha senha
          </p>
        ) : null}

        <Button
          disabled={isSubmitting}
          type="submit"
          onMouseEnter={() => {
            playSong(songsName.TAP)
          }}
          onClick={() => {
            playSong(songsName.TAP)
          }}
        >
          {isSubmitting ? (
            <Loader
              type="Oval"
              visible={true}
              color="white"
              width={16}
              height={16}
              className="flex flex-1 justify-center items-center"
            />
          ) : "Enviar"}
        </Button>

        {method.ativacao ? (
          <div className='mt-6 flex flex-col justify-center items-center'>
            <span className='mb-2 text-sm text-center'>
              {method.ativacao_descricao}
            </span>

            <GhostButton onClick={openConfirmationModal}>
              Primeiro acesso?
            </GhostButton>
          </div>
        ) : null}
      </form>
    )
  }, [access, errors, forgotPasswordHandler, handleBlur, handleChange, handleSubmit, isLoading, isSubmitting, method, props, showRecoveryPasswordForm, touched, values])

  const renderContentKey = useMemo(() => {
    if (isLoading) {
      return "loading"
    }

    if (showRecoveryPasswordForm) {
      return "showRecoveryPasswordForm"
    }

    if (!method) {
      return "access"
    }

    if (method && method?.patterns?.length) {
      return "patterns"
    }

    return "loginForm"
  }, [isLoading, method, showRecoveryPasswordForm])

  const openConfirmationModal = () => {
    setShowFirstAccessConfirmationModal(true)
  }

  const closeConfirmationModal = () => {
    setShowFirstAccessConfirmationModal(false)
  }

  const openLinkHandler = () => {
    if (window.in_native_app) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'OPEN_LINK',
        payload: {
          uri: method.ativacao_URL
        }
      }))
    }
  }
    
  return (
    <>
      <Drawer
        dontApplyListeners={true}
        allowClose={false}
        open={props.isOpened}
        onRequestClose={closeHandler}
        direction="left"
        modalElementClass="absolute top-0 left-0"
      >
        <div
          className={clsx('w-screen max-w-lg h-screen bg-modal flex flex-col justify-start items-start px-4 pb-4 text-lg overflow-y-auto')}
          style={{
            paddingTop: window.native_app_status_bar_height ?? 16
          }}
        >
          <div className='w-full flex flex-row justify-between items-center'>
            <div
              className='flex flex-row justify-start items-center cursor-pointer'
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={() => {
                playSong(songsName.TAP)

                if (showRecoveryPasswordForm) {
                  setShowRecoveryPasswordForm(false)

                  return
                }

                if (!method) {
                  props.backToDrawerMenu()

                  return
                }

                resetForm({ email: "", msisdn: "", password: "", cpfcnpj: "", username: "" })

                if (showRecoveryPasswordForm) {
                  setShowRecoveryPasswordForm(false)

                  return
                }

                if (isPatternSelectedForLogin) {
                  const patternsAccess = access?.find(item => !!item.patterns)
                  setMethod(patternsAccess)

                  return
                }

                setMethod(null)
              }}
            >
              <BsArrowLeftCircle className="w-8 h-8 text-blue-primary" />
            </div>

            <img src={LogoPng} className='w-40 h-12 mx-auto' alt='Logo' />

            <button
              type="button"
              onMouseEnter={() => {
                playSong(songsName.TAP)
              }}
              onClick={closeHandler}
              className={`text-black bg-transparent hover:bg-slate-200 rounded-lg text-2xl lg:text-xl`}
            >
              <FiX className="w-8 h-8 text-blue-primary" />
            </button>
          </div>

          <h2
            className='text-blue-primary font-bold text-xl text-center mx-auto my-8'
            dangerouslySetInnerHTML={{ __html: !method ? 'Escolha a forma de <br /> começar a navegar' : method.operadora ?? method.item }}
          />
          
          <AnimatePresence mode="wait">
            <motion.div
              key={renderContentKey}
              variants={slideVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              custom={0.2}
              className="w-full flex flex-col gap-y-4"
            >
              {renderContent()}
            </motion.div>
          </AnimatePresence>
        </div>
      </Drawer>

      <Drawer
        direction="bottom"
        open={showFirstAccessConfirmationModal}
        dontApplyListeners={true}
        onRequestClose={closeConfirmationModal}
        containerElementClass="px-6"
      >
        <div className='w-full bg-white rounded-xl p-6 space-y-2 relative text-blue-primary text-center'>
          <button className='ml-6 bg-white border-0 absolute top-4 right-4' onClick={closeConfirmationModal}>
            <BsX className='w-8 h-8 text-blue-primary' />
          </button>

          <img src={LogoPng} className='w-40 h-12 mx-auto' alt='Logo' />
          <br />
          <br />

          <p className='font-bold'>{method?.ativacao_instrucao ?? ''}</p>
          <br />
          <br />

          <Button onClick={openLinkHandler}>Continuar</Button>
          <GhostButton onClick={closeConfirmationModal}>Fechar</GhostButton>
        </div>
      </Drawer>
    </>
  )
}

export default LoginModal